import {ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {ControlValueAccessor} from '@angular/forms';
import {Destroyable} from "@frontend-site/shared/utils";
import {IPField} from '@panaya/ui/p-field';
import {LegacyCompatibilityType} from "../types/legacy-compatibility.types";

// ===================================================================================================
// p fields not support control.disable/ control.enabled
// In order to support need to change setDisabledState to be as it is in current class
// This class is used for p-field-slide-toggle-workaround (field type: BOOLEAN_WORKAROUND)
// The use case is: Test details> general tab > changed reviewed to yes (in regulated cycle) - form should be disabled except of 'reviewed' field which should remain enabled.
// IMPORTANT NOTE: isDisabled input must be sent to p-field component
// ===================================================================================================
@Component({
    template: ``
})
export abstract class PFieldAbstractWorkaroundComponent<T> extends Destroyable implements ControlValueAccessor, IPField<T> {
    @Input() value: any;

    @Input() isReadOnly = false;

    @Input() isDisabled = false;

    @Input() isValid = true;

    @Input() ariaLabel?: string;

    @Input() valueTooltip: string = '';
    @Input() labelTooltip: string = '';

    @Input() shouldTransformLabelTextCase = true;

    @Output() public readonly viewValueChanged = new EventEmitter<T | undefined | LegacyCompatibilityType>;
    /**
     * @deprecated Please use {@link viewValueChanged} instead.
     */
    @Output() public readonly valueChange = this.viewValueChanged;

    touched = false;

    public setValue(value: T): void {
        this.value = value;
    }

    protected _onChange: (v: any) => void = (v) => {
        this.viewValueChanged.emit(v);
    };

    protected _onTouch: () => void = () => {
        this.cd.detectChanges();
    };

    protected constructor(protected cd: ChangeDetectorRef) {
        super();
    }

    protected markAsTouched() {
        if (!this.touched) {
            this._onTouch();
            this.touched = true;
        }
    }

    registerOnChange(fn: (v: T) => void): void {
        this._onChange = (v) => {
            fn(v);
            this.viewValueChanged.emit(v);
        };
    }

    registerOnTouched(fn: () => void): void {
        this._onTouch = () => {
            fn();
            this.cd.detectChanges();
        };
    }


    writeValue(obj: T): void {
        this.value = obj;
        this.cd.detectChanges();
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
        this.cd.detectChanges();
    }
}
